import { useActiveWeb3React } from '.'
import { useMasterChief } from './useContract'
import { useEffect, useState } from 'react'

const useFarmingPools = () => {
  const { account } = useActiveWeb3React()
  const isActive = !!account
  const masterChiefContract = useMasterChief()
  const [pools, setPools] = useState<any>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPools = async () => {
      if (isActive && masterChiefContract && loading) {
        try {
          setLoading(true)
          const poolLength = await masterChiefContract.poolLength()
          const poolList: any = []

          for (let i = 0; i < poolLength.toNumber(); i++) {
            const poolData = await masterChiefContract.poolInfo(i)

            poolList.push(poolData)
          }

          setPools(poolList)
          setLoading(false)
        } catch (error) {
          console.error('Error fetching pools:', error)
        } finally {
          setLoading(false)
        }
      }
    }

    fetchPools()
  }, [isActive, masterChiefContract, loading])

  return {
    pools,
    loading,
    refresh: () => {
      setLoading(true)
    },
  }
}

export default useFarmingPools
